/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/tipologia";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/tipologia/tipologia",
            controller: 'TipologiaAdminController',
            controllerForm: 'TipologiaFormAdminController',
            translateBase: "admin.tipologia."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear


        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
    }
})();
